import React from 'react';
import { Typography } from '@/components/Typography/Typography';
import { clsx } from 'clsx';
import { Container } from '@/components/Containers/Container';

export const ConnectRealGenerative = () => {
  return (
    <section className={clsx('relative lg:bg-light bg-purple_ley')}>
      <Container className="md:pt-24.5-vw pt-15">
        <div className="relative">
          <div className="z-10 flex flex-col justify-center items-center lg:gap-7.5-vw gap-6 relative">
            <div className="bg-purple_ley flex max-md:flex-col lg:gap-7.5-vw gap-7 items-center w-full md:rounded-lg-20-vw rounded-md-10 z-10 lg:pt-7.5-vw lg:pr-24.5-vw lg:pl-24.5-vw">
              <div className="lg:max-w-[59.444vw] lg:w-1/2">
                <Typography as="h2" $weight="700" $type="Heading1" className="font-formula">
                  Connect Real Generative AI to Your Chat
                </Typography>
                <Typography $type="Heading4" className="font-jamjuree">
                  Let CoSupport AI integrate the{' '}
                  <b>
                    <i>AI-powered chatbot</i>
                  </b>{' '}
                  with your Freshdesk chat!
                </Typography>
              </div>
              <div className="flex flex-col lg:w-1/2 w-full items-center">
                <picture className="w-full h-full object-contain">
                  <source
                    srcSet="/img/freshdesk-integration/connect-real-generative.webp"
                    media="(min-width: 640px)"
                  />
                  <img
                    className="h-full w-full object-contain object-bottom"
                    src="/img/freshdesk-integration/connect-real-generative.webp"
                    alt={`connect-real-generative image`}
                  />
                </picture>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </section>
  );
};
